import React from "react";
import { Chip } from "@mui/material";
import { formatImportStatusValue, formatMappingStateValue, normalizeMappingStateKey } from "./legendsContent";

export const getImportStatusChipClass = (status) => {
  if (status === "COMPLETED") return "cm-chip-success";
  if (status === "COMPLETED_WITH_WARNINGS") return "cm-chip-warning";
  if (status === "COMPLETED_WITH_ERRORS") return "cm-chip-error";
  if (status === "MAPPING_REVIEW") return "cm-chip-info";
  if (status === "PARTIAL_FAILED") return "cm-chip-warning";
  if (status === "DOWNLOAD_FAILED" || status === "PARSE_FAILED" || status === "FAILED") return "cm-chip-error";
  if (status === "RUNNING") return "cm-chip-info";
  if (status === "CANCELLED") return "cm-chip-warning";
  return "cm-chip-neutral";
};

export const getMappingStateChipProps = (state) => {
  const key = normalizeMappingStateKey(state);
  const label = formatMappingStateValue(state);
  if (key === "auto") {
    return { label, className: "cm-chip-info" };
  }
  if (key === "auto_warn") {
    return { label, className: "cm-chip-warning" };
  }
  if (key === "auto_err") {
    return { label, className: "cm-chip-warning" };
  }
  if (key === "manual") {
    return { label, className: "cm-chip-success" };
  }
  if (key === "manual_warn") {
    return { label, className: "cm-chip-warning" };
  }
  if (key === "manual_err") {
    return { label, className: "cm-chip-warning" };
  }
  return { label, className: "cm-chip-neutral" };
};

export const CatalogMappingStateChip = ({ mappingState }) => {
  const chip = getMappingStateChipProps(mappingState);
  return <Chip size="small" className={chip.className} label={chip.label} />;
};

export const CatalogImportStatusChip = ({ status, fallbackLabel = "N/D" }) => {
  const value = formatImportStatusValue(status) === "N/D" ? fallbackLabel : formatImportStatusValue(status);
  return <Chip size="small" className={getImportStatusChipClass(status)} label={value} />;
};
